var exports = {
  "uu": "VoiceLobbyShared.module__actionButtons___cFNsaW",
  "hP": "VoiceLobbyShared.module__actionButton___cFNsaW",
  "zc": "VoiceLobbyShared.module__iconContainer___cFNsaW",
  "KA": "VoiceLobbyShared.module__iconContainerBrand___cFNsaW",
  "cF": "VoiceLobbyShared.module__iconContainerDanger___cFNsaW",
  "hO": "VoiceLobbyShared.module__iconContainerTertiary___cFNsaW",
  "cY": "VoiceLobbyShared.module__iconContainerSuccess___cFNsaW",
  "gE": "VoiceLobbyShared.module__actionIcon___cFNsaW",
  "uI": "VoiceLobbyShared.module__actionIconSecondary___cFNsaW",
  "K2": "VoiceLobbyShared.module__actionText___cFNsaW",
  "Hd": "VoiceLobbyShared.module__connectionInfo___cFNsaW",
  "Il": "VoiceLobbyShared.module__connectionHeader___cFNsaW",
  "p1": "VoiceLobbyShared.module__connectionStatusInfo___cFNsaW",
  "bn": "VoiceLobbyShared.module__connectionTitle___cFNsaW",
  "fV": "VoiceLobbyShared.module__connectionSubtitle___cFNsaW",
  "Cb": "VoiceLobbyShared.module__connectionStatusDot___cFNsaW",
  "wL": "VoiceLobbyShared.module__statsGrid___cFNsaW",
  "N8": "VoiceLobbyShared.module__statRow___cFNsaW",
  "Zh": "VoiceLobbyShared.module__statLabel___cFNsaW",
  "cR": "VoiceLobbyShared.module__statValue___cFNsaW",
  "_x": "VoiceLobbyShared.module__statValuePrimary___cFNsaW",
  "V4": "VoiceLobbyShared.module__endpointValue___cFNsaW",
  "TR": "VoiceLobbyShared.module__connectionIdValue___cFNsaW",
  "JX": "VoiceLobbyShared.module__maxWidth___cFNsaW",
};

module.exports = exports;
